import LandingConstants from 'constants/landing';
import LandingService from 'services/landing';
import Flux from 'lib/flux';

const LandingActionCreator = Flux.createActionCreator({
  fetchTours() {
    const self = this;

    this.dispatchAction(LandingConstants.FETCH_TOURS);

    LandingService.fetchTours().then(function (resp) {
      self.dispatchAction(LandingConstants.FETCH_TOURS_COMPLETED, resp);
    });
  },
});

export default LandingActionCreator;
